module.exports = __webpack_public_path__ + "media/images/front/icons/favorite-eb14e554824bf77084dcadbe46f6dc08.png";